import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { TableRow, TableCell } from '@mui/material';
import { DynamicField } from '@totalsoft/rocket-ui';
import { withRights } from 'providers/RightsConsumer';
import { getDynamicFieldProperties } from 'utils/functions';

export const OfferPartnerMonthlyObligationsItem = ({ item, editable, idx, onPropertyChange }) => {
  const handlePropertyItemChange = useCallback(
    value => {
      onPropertyChange('value', value);
    },
    [onPropertyChange]
  );

  return (
    <TableRow>
      <TableCell id={'offerPartnerMonthlyObligationsCard_' + idx + '_name'}>{item.name}</TableCell>
      <TableCell>
        <DynamicField
          id={'offerPartnerMonthlyObligationsCard_' + idx + '_value'}
          {...getDynamicFieldProperties(item.typeCode)}
          onChange={handlePropertyItemChange}
          value={item.value || ''}
          disabled={!editable}
        />
      </TableCell>
    </TableRow>
  );
};

OfferPartnerMonthlyObligationsItem.propTypes = {
  item: PropTypes.object.isRequired,
  editable: PropTypes.bool.isRequired,
  onPropertyChange: PropTypes.func.isRequired,
  idx: PropTypes.number.isRequired
};

export default withRights(OfferPartnerMonthlyObligationsItem);
